<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <p-skeleton width="10rem" height="1.5rem" class="mb-2" />
        <p-skeleton width="18rem" height="0.875rem" />
      </div>
      <div class="flex-1 min-h-0 overflow-auto p-4">
        @for (row of skeletonRows; track row) {
          <p-skeleton height="2.5rem" class="mb-2" />
        }
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <p class="text-red-800">{{ error() }}</p>
      <button (click)="loadEmails()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg">Reintentar</button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
                  <i class="pi pi-envelope"></i>
                </span>
                Comunicados
              </h2>
              <p class="text-sm text-slate-500 mt-1">Historial de correos enviados por la plataforma.</p>
            </div>
            <p-button label="Actualizar" icon="pi pi-refresh" severity="secondary" size="small" [rounded]="true" [loading]="loading()" (onClick)="loadEmails()" />
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <p-floatlabel class="w-full min-w-0 xl:w-48" variant="on">
              <input pInputText id="filterSubject" formControlName="subject" class="w-full p-inputtext-sm" autocomplete="off" />
              <label for="filterSubject">Asunto</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-48" variant="on">
              <input pInputText id="filterFrom" formControlName="from" class="w-full p-inputtext-sm" autocomplete="off" />
              <label for="filterFrom">Remitente</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-48" variant="on">
              <input pInputText id="filterTo" formControlName="to" class="w-full p-inputtext-sm" autocomplete="off" />
              <label for="filterTo">Destinatario</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-48" variant="on">
              <input pInputText id="filterCustomer" formControlName="customer" class="w-full p-inputtext-sm" autocomplete="off" />
              <label for="filterCustomer">Cliente</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
              <p-select
                formControlName="status"
                inputId="filterStatus"
                [options]="statusOptions"
                optionLabel="label"
                optionValue="value"
                [showClear]="true"
                size="small"
                class="w-full" />
              <label for="filterStatus">Estado</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
              <p-datepicker
                inputId="filterCreatedAt"
                formControlName="createdAtRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                appendTo="body"
                class="w-full" />
              <label for="filterCreatedAt">Fecha envío</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="emails()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} correos"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="onLazyLoad($event)"
            styleClass="comunicados-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>Destinatario</th>
                <th class="hidden sm:table-cell">Cliente</th>
                <th class="hidden md:table-cell">Asunto</th>
                <th class="hidden md:table-cell">Venta</th>
                <th class="hidden md:table-cell">Suscripción</th>
                <th class="hidden md:table-cell">Liga</th>
                <th class="hidden lg:table-cell">Usuario</th>
                <th class="hidden md:table-cell text-center">Adjuntos</th>
                <th class="hidden sm:table-cell">Fecha envío</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-email>
              <tr class="cursor-pointer hover:!bg-indigo-50/50 transition-colors" (click)="openDetails(email)">
                <td>
                  <div class="flex items-center gap-2 min-w-0">
                    <div class="relative shrink-0 h-8 w-8 overflow-visible">
                      <span
                        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600"
                        [pTooltip]="emailStatusTooltip(email)"
                        tooltipPosition="top">
                        <i class="pi pi-envelope text-sm"></i>
                      </span>
                      @if (email.status === 'SENT' && email.openedAt) {
                        <span
                          class="email-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-0 h-4 w-4 rounded-full bg-blue-500 text-white ring-2 ring-white shadow"
                          [pTooltip]="emailStatusTooltip(email)"
                          tooltipPosition="bottom">
                          <i class="pi pi-eye !text-[9px]"></i>
                        </span>
                      } @else if (email.status === 'SENT') {
                        <span
                          class="email-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-0 h-4 w-4 rounded-full bg-emerald-500 text-white ring-2 ring-white shadow"
                          pTooltip="Enviado"
                          tooltipPosition="bottom">
                          <i class="pi pi-check !text-[9px]"></i>
                        </span>
                      } @else if (email.status === 'FAILED') {
                        <span
                          class="email-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-0 h-4 w-4 rounded-full bg-red-500 text-white ring-2 ring-white shadow"
                          pTooltip="Fallido"
                          tooltipPosition="bottom">
                          <i class="pi pi-times !text-[9px]"></i>
                        </span>
                      } @else if (email.status === 'SUPPRESSED') {
                        <span
                          class="email-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-0 h-4 w-4 rounded-full bg-slate-400 text-white ring-2 ring-white shadow"
                          [pTooltip]="emailStatusTooltip(email)"
                          tooltipPosition="bottom">
                          <i class="pi pi-ban !text-[9px]"></i>
                        </span>
                      }
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm text-slate-900 truncate" [title]="email.toAddresses">{{ email.toAddresses || '—' }}</div>
                      <div class="text-xs text-slate-500 truncate" [title]="email.fromAddress">{{ email.fromAddress || '—' }}</div>
                    </div>
                  </div>
                </td>
                <td class="hidden sm:table-cell max-w-[12rem]" (click)="$event.stopPropagation()">
                  @if (email.customerId && customerDisplayName(email)) {
                    <button
                      type="button"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline truncate max-w-full"
                      [title]="customerDisplayName(email)"
                      (click)="openCustomerDetails(email.customerId)">
                      {{ customerDisplayName(email) }}
                    </button>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </td>
                <td class="hidden md:table-cell"><span class="text-sm truncate block max-w-[14rem]" [title]="email.subject">{{ email.subject || '—' }}</span></td>
                <td class="hidden md:table-cell max-w-[10rem]" (click)="$event.stopPropagation()">
                  @if (email.saleId) {
                    <button
                      type="button"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline whitespace-nowrap"
                      (click)="openSaleDetails(email.saleId)">
                      {{ email.saleNumber || ('Venta #' + email.saleId) }}
                    </button>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </td>
                <td class="hidden md:table-cell max-w-[10rem]" (click)="$event.stopPropagation()">
                  @if (email.subscriptionId) {
                    <button
                      type="button"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline whitespace-nowrap"
                      (click)="openSubscriptionDetails(email.subscriptionId)">
                      {{ email.subscriptionNumber || ('Suscripción #' + email.subscriptionId) }}
                    </button>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </td>
                <td class="hidden md:table-cell max-w-[10rem]" (click)="$event.stopPropagation()">
                  @if (email.saleLinkId) {
                    <button
                      type="button"
                      class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline whitespace-nowrap"
                      (click)="openSaleLinkDetails(email.saleLinkId)">
                      {{ email.saleLinkNumber || ('Liga #' + email.saleLinkId) }}
                    </button>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </td>
                <td class="hidden lg:table-cell">
                  <span class="text-sm truncate block max-w-[10rem]" [title]="email.triggeredByUserEmail || ''">
                    {{ email.triggeredByUserName || email.triggeredByUserEmail || 'Sistema' }}
                  </span>
                </td>
                <td class="hidden md:table-cell text-center">
                  @if (email.attachments?.length) {
                    <i class="pi pi-check text-emerald-600" aria-label="Con adjuntos"></i>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </td>
                <td class="hidden sm:table-cell text-sm text-slate-600">{{ email.sentAt ? (email.sentAt | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9" class="text-center py-8 text-slate-500">No hay comunicados registrados.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>
</div>

<p-drawer
  [visible]="detailsOpen()"
  (visibleChange)="detailsOpen.set($event)"
  position="right"
  styleClass="email-audit-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3 min-w-0">
      <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600 shadow-sm">
        <i class="pi pi-envelope text-base"></i>
      </span>
      <h3 class="text-lg font-semibold text-slate-900">Detalle del correo</h3>
    </div>
  </ng-template>
  @if (detailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-indigo-500"></i>
      <p class="text-sm text-slate-600">Cargando correo...</p>
    </div>
  } @else if (selectedEmail(); as email) {
    <app-email-audit-read
      [email]="email"
      (openCustomer)="openCustomerDetails($event)"
      (openSale)="openSaleDetails($event)"
      (openSubscription)="openSubscriptionDetails($event)"
      (openSaleLink)="openSaleLinkDetails($event)" />
  }
</p-drawer>

<p-drawer
  [visible]="isSaleDetailsOpen()"
  position="right"
  (visibleChange)="onSaleDrawerVisibleChange($event)"
  styleClass="sale-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
          <i class="pi pi-shopping-cart text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
      </div>
      @if (selectedSale() && !saleDetailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editSaleFromModal()">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (saleDetailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando detalle...</p>
    </div>
  } @else if (selectedSale()) {
    <app-sale-read
      [sale]="selectedSale()!"
      [charges]="saleCharges()"
      (openCustomer)="openCustomerDetails($event)"
      (openSubscription)="openSubscriptionDetails($event)" />
  }
</p-drawer>

<p-drawer
  [visible]="isCustomerDetailsOpen()"
  position="right"
  (visibleChange)="onCustomerDrawerVisibleChange($event)"
  styleClass="customer-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-user text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
      </div>
      @if (selectedCustomer() && !customerDetailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editCustomerFromModal()">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (customerDetailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando cliente...</p>
    </div>
  } @else if (selectedCustomer()) {
    <app-customer-read
      [customer]="selectedCustomer()!"
      (openSale)="openSaleDetails($event)" />
  }
</p-drawer>

<p-drawer
  [visible]="isSubscriptionDetailsOpen()"
  position="right"
  (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
  styleClass="subscription-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
          <i class="pi pi-sync text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
      </div>
      @if (selectedSubscription() && !subscriptionDetailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editSubscriptionFromModal()">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (subscriptionDetailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
      <p class="text-sm text-slate-600">Cargando suscripción...</p>
    </div>
  } @else if (selectedSubscription()) {
    <app-subscription-read
      [subscription]="selectedSubscription()!"
      (openSale)="openSaleDetails($event)" />
  }
</p-drawer>

<p-drawer
  [visible]="isSaleLinkDetailsOpen()"
  position="right"
  (visibleChange)="onSaleLinkDrawerVisibleChange($event)"
  styleClass="sale-link-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600 shadow-sm">
          <i class="pi pi-link text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de liga de pago</h3>
      </div>
      @if (selectedSaleLink() && !saleLinkDetailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editSaleLinkFromModal()">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (saleLinkDetailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-indigo-500"></i>
      <p class="text-sm text-slate-600">Cargando liga de pago...</p>
    </div>
  } @else if (selectedSaleLink()) {
    <app-sale-link-read [link]="selectedSaleLink()!" />
  }
</p-drawer>
